import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import { getGetSignalTimelineQueryKey } from '@/api/signals.hook'
import { ControlInventoryService } from '@/gen/inventory/v1/control_service_pb'
import { addSignalComment } from '@/gen/inventory/v1/signal_service-SignalService_connectquery'

import { defaultTransport } from '@/lib/connect/connect-transport'

export const getControlQueryKey = (controlId?: string) => {
  return createConnectQueryKey({
    schema: ControlInventoryService.method.getControl,
    input: { controlId },
    cardinality: 'finite',
    transport: defaultTransport,
  })
}

export const getControlTimelineQueryKey = (controlId?: string) => {
  return createConnectQueryKey({
    schema: ControlInventoryService.method.getControlTimeline,
    input: { controlId },
    cardinality: 'finite',
    transport: defaultTransport,
  })
}

export const useAddSignalComment = (signalId: string) => {
  const queryClient = useQueryClient()

  return useMutation(addSignalComment, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getGetSignalTimelineQueryKey(signalId) })
    },
  })
}
